import CommentsTextArea from './CommentsTextArea';

export default CommentsTextArea;
